import PreRegisterModalComponent from './pre-register-modal-component'
import PreRegisterModalService from './pre-register-modal-service'

/***
 * The modal that pops up on the User Admin page, allowing you to pre-register a user so that when they sign in for the
 * first time, they are already authorized and have clients assigned to them.
 */
const preRegisterModal = angular
    .module('FacilityData.UserAdmin.PreRegisterModal', [])
    .component('preRegisterModal', PreRegisterModalComponent)
    .service('PreRegisterModalService', PreRegisterModalService)
    .name;

export default preRegisterModal;


// WEBPACK FOOTER //
// ./app/components/user-admin/pre-register-modal/pre-register-modal.js